import { PropertyService } from './../api/property.service';
import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector } from '@angular/core';
import { Property, Reason } from '../models/index';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './base-component';
import { OpenModalService } from './shared/modals/open-modal.service';

@Component({
  selector: 'app-home-base',
  template: ''
})

export class HomeBaseComponent extends BaseComponent implements OnInit {
  properties: Property[] = [];
  reasons: Reason[] = [];

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    public propertyService: PropertyService,
    public openModalService: OpenModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const promise = this.propertyService.getPromoProperties();

    if (promise) {
      promise.then(properties => {
        this.properties = properties;
      });
    }

    this.route.data.forEach((data: { reasons: Reason[] }) => {
      if (data.reasons)
        this.reasons = data.reasons;
    });

    this.setTitle(this.agencyService.agency.name);
  }

  openReasonModal(reason: Reason): void {
    this.openModalService.showDetailsModal(reason.name, undefined, reason.description, reason.image);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/home-base.component.ts